import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import i18n from './i18n'
import * as ConcorsandoApi from "./lib/ConcorsandoApi"
import store from './store/index'
import ImagesClient from "./lib/ConcorsandoWasm/ImagesClient";
import CustomClient from "@/lib/CustomConcorsandoClient/api/CustomClient";
import BandiClient from "@/lib/CustomConcorsandoClient/api/BandiClient";
import RuntimeConfig from "@/helpers/RuntimeConfig";

import { app, analytics } from "@/firebase";
import { setAnalyticsCollectionEnabled } from "firebase/analytics";

import {setupCookieBot} from "@/setupCookieBot";
/* import BrevoClient from "./lib/CustomConcorsandoClient/api/BrevoClient"; */

const defaultClient = ConcorsandoApi.ApiClient.instance;
const imagesClient = ImagesClient.instance;
const customClient = CustomClient.instance;
const bandiClient = BandiClient.instance;
const runtimeConfig = RuntimeConfig.instance;
/* const defaultClientBrevo = BrevoClient.instance */

if (process.env.VUE_APP_BACKEND_URL) {
  defaultClient.basePath = process.env.VUE_APP_BACKEND_URL
  imagesClient.basePath = process.env.VUE_APP_IMAGES_BASE_PATH
  customClient.basePath = process.env.VUE_APP_SEGNALAZIONE_BASE_PATH
  bandiClient.basePath = process.env.VUE_APP_BANDI_BASE_PATH
  runtimeConfig.appleRedirectUrl = process.env.VUE_APP_APPLE_REDIRECT_URL
  runtimeConfig.helloJSRedirectUrl = process.env.VUE_APP_HELLOJS_REDIRECT_URL
  runtimeConfig.paypalClientId = process.env.VUE_APP_PAYPAL_CLIENT_ID
  runtimeConfig.paypalBaseUrl = process.env.VUE_APP_PAYPAL_BASE_URL || "https://www.paypal.com"
  runtimeConfig.reCaptchaSiteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY
  /* defaultClientBrevo.basePath = process.env.VUE_APP_BACKEND_BREVO_URL */
}
else if (process.env.NODE_ENV === "development") {
  defaultClient.basePath = 'https://test.api.concorsando.it/ws/api'
  imagesClient.basePath = 'https://www.concorsando.it/files/q_pics'
  customClient.basePath = 'https://www.concorsando.it/api/v4'
  bandiClient.basePath = 'https://www.concorsando.it/blog/wp-json/eventon/events'
  runtimeConfig.appleRedirectUrl = "https://simulatoreweb.southengineering.it/simulatore/auth"
  runtimeConfig.helloJSRedirectUrl = "/simulatore/auth/"
  runtimeConfig.paypalClientId = process.env.VUE_APP_PAYPAL_CLIENT_ID || "AVJmUhOqjJ6PLqqO84s-3C0Hj6hnsUXxv-xQfcIwBsLTqGbgcLkwoAjzIqbhne0zHp9wLjwTu5Dzy7Qe"
  runtimeConfig.paypalBaseUrl = process.env.VUE_APP_PAYPAL_BASE_URL || "https://sandbox.paypal.com"
  // Chiave di sviluppo dalla documentazione di google: 6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI
  runtimeConfig.reCaptchaSiteKey = "6Ld5vRAaAAAAAHBh6MgT0EZR6gOP9Nz8zBEliVif"
  /* defaultClientBrevo.basePath = "https://api.brevo.com/v3" */

}

if (process.env.VUE_APP_ORIGIN) {
  defaultClient.defaultHeaders['x-requested-with'] = process.env.VUE_APP_ORIGIN
  imagesClient.defaultHeaders['x-requested-with'] = process.env.VUE_APP_ORIGIN
  customClient.defaultHeaders['x-requested-with'] = process.env.VUE_APP_ORIGIN
  bandiClient.defaultHeaders['x-requested-with'] = process.env.VUE_APP_ORIGIN
} else if (process.env.NODE_ENV === "development") {
  defaultClient.defaultHeaders['x-requested-with'] = 'https://concorsando.it'
  imagesClient.defaultHeaders['x-requested-with'] = 'https://concorsando.it'
  customClient.defaultHeaders['x-requested-with'] = 'https://concorsando.it'
  bandiClient.defaultHeaders['x-requested-with'] = 'https://concorsando.it'
}

const tokenApi = store.getters['auth/token_api'];
if (tokenApi && tokenApi !== "") {
  const Baerer = defaultClient.authentications['Baerer'];
  Baerer.apiKey = tokenApi;
  Baerer.apiKeyPrefix = 'Bearer';

  // Avviamo il ripristino dell'auth (decriptazione token)
  // La navigazione sarà gestita dal router.beforeEach che attenderà il completamento
  store.dispatch('auth/updateAuthenticationStatus');

  const profile = store.getters['auth/profile'];
  
  if (profile && profile.id_utente_concorsando) {
      store.dispatch('notifications/LOAD_NOTIFICATIONS', profile.id_utente_concorsando);
  }
}

Vue.use(Vuelidate)

setAnalyticsCollectionEnabled(analytics, false);

Vue.prototype.$analytics = analytics;

setupCookieBot({ app, analytics });

Vue.prototype.$MathJax = window.MathJax;

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
